import React, { useEffect, useState } from "react";
import { Table, Button, Pagination, message } from "antd";
import UserDetail from "../pages/UserDetail";
import SendSolapiModal from "../pages/SendSolapiModal";
import { subItemHooks } from "../hooks";
const BannerLayout = () => {
  const [banners, setBanners] = useState([]); // 배너 리스트
  const [loading, setLoading] = useState(false); // 로딩 상태
  const [page, setPage] = useState(1); // 현재 페이지
  const [total, setTotal] = useState(0); // 총 데이터 수
  const [selectedBanner, setSelectedBanner] = useState(null); // 선택한 배너 데이터
  const [isModalVisible, setIsModalVisible] = useState(false); // 모달 상태
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // API 호출 함수
  const fetchBanners = async (currentPage = 1) => {
    setLoading(true);
    try {
      const response = await subItemHooks.userList({ page: currentPage });
      console.log("response : ",response.data)
      const { data, cnt } = response.data;
      console.log(data);
      setBanners(data);
      setTotal(cnt);
    } catch (error) {
      console.error("유저 데이터를 가져오는 중 오류가 발생했습니다.", error);
    } finally {
      setLoading(false);
    }
  };
  const handleCreate = async (newProduct) => {
      try {
        const res = await subItemHooks.productCreate({
          brandName: newProduct.brand_name,
          contentId: "",
          productLink: newProduct.product_link,
          productPrice: newProduct.product_price,
          productThumbnail: newProduct.product_thumbnail.split(",")[1],
          productTitle: newProduct.product_title,
        });
        if (res.IsError) {
          throw new Error("create banner error");
        }
        message.success("새 상품이 생성되었습니다.");
        fetchBanners(page);
        setIsCreateModalVisible(false);
      } catch (error) {
        console.error("상품 생성 중 오류가 발생했습니다.", error);
        message.error("상품 생성에 실패했습니다.");
      }
    };


  useEffect(() => {
    fetchBanners(page);
  }, [page]);

  // 테이블 컬럼 정의
  const columns = [
    {
      title: "이름",
      dataIndex: "user_name",
    },
    {
      title: "성별",
      dataIndex: "gender",
      render: (gender) =>
        (function () {
          if (gender === "1") {
            return "남성";
          } else {
            return "여성";
          }
        })(),
    },
    {
      title: "생년월일",
      dataIndex: "birth",
    },
    {
      title: "전화번호",
      dataIndex: "hp",
      
    },
    {
      title: "아기정보",
      dataIndex: "babies",
      render: (babies) => babies && babies[0] && babies[0].name || "없음",
    },
    {
      title: "가입일자",
      dataIndex: "created_at",
    },
    {
      title: "상세보기",
      render: (record) => (
        <Button
          type="link"
          onClick={() => {
            setSelectedBanner(record);
            setIsModalVisible(true);
          }}
        >
          상세 보기
        </Button>
      ),
    },
  ];
 const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
  };
  return (
    <div>
      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button type="primary" onClick={() => setIsCreateModalVisible(true)}>
          솔리피 전송
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={banners}
        rowKey="user_id"
        pagination={false}
        loading={loading}
        rowSelection={rowSelection} 
      />
      <Pagination
        current={page}
        total={total}
        pageSize={10}
        onChange={(page) => setPage(page)}
        style={{ marginTop: 20, textAlign: "center" }}
      />
      <UserDetail
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        banner={selectedBanner}
        // onUpdate={handleUpdate}
        // onDelete={handleDelete}
      />
      {isCreateModalVisible && (
        <SendSolapiModal
          visible={isCreateModalVisible}
          onClose={() => setIsCreateModalVisible(false)}
          onCreate={handleCreate}
          selectedIds={selectedRowKeys} 
        />
      )}
    </div>
  );
};

export default BannerLayout;
